import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-color-um-blue"
}
const _hoisted_2 = {
  key: 1,
  class: "text-color-um-blue"
}
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = { class: "grid productInfoGrid" }
const _hoisted_5 = {
  key: 0,
  class: "col"
}
const _hoisted_6 = { class: "text-color-um-blue" }
const _hoisted_7 = { class: "product__accordion" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "col"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_13 = { style: {"font-size":"18px"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-right" }, null, -1)
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_18 = { class: "grid" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "text-color-um-blue" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "text-color-um-blue" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = {
  key: 0,
  class: "col"
}
const _hoisted_28 = { class: "text-color-um-blue" }
const _hoisted_29 = { class: "col" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "text-color-um-blue" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_33 = { class: "grid" }
const _hoisted_34 = {
  key: 0,
  class: "col"
}
const _hoisted_35 = { class: "text-color-um-blue" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = {
  key: 1,
  class: "col"
}
const _hoisted_43 = { class: "text-color-um-blue" }
const _hoisted_44 = {
  key: 2,
  class: "col"
}
const _hoisted_45 = { class: "text-color-um-blue" }
const _hoisted_46 = {
  key: 3,
  class: "col"
}
const _hoisted_47 = { class: "text-color-um-blue" }
const _hoisted_48 = {
  key: 4,
  class: "col"
}
const _hoisted_49 = { class: "text-color-um-blue" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_51 = { class: "grid" }
const _hoisted_52 = { class: "col" }
const _hoisted_53 = { class: "text-color-um-blue" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_55 = { class: "grid" }
const _hoisted_56 = { class: "col" }
const _hoisted_57 = { class: "text-color-um-blue" }
const _hoisted_58 = {
  class: "col",
  style: {"max-width":"600px"}
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-5 mb-4" }, null, -1)
const _hoisted_61 = { style: {"max-width":"250px"} }
const _hoisted_62 = {
  class: "text-left",
  style: {"max-width":"295px","margin":"0 auto"}
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Galleria = _resolveComponent("Galleria")!
  const _component_IconTextBlock = _resolveComponent("IconTextBlock")!
  const _component_GoogleMapsSmall = _resolveComponent("GoogleMapsSmall")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AddToCompare = _resolveComponent("AddToCompare")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Prompt = _resolveComponent("Prompt")!
  const _component_Register = _resolveComponent("Register")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.item)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.state.class)
        }, [
          (_ctx.defaultLanguageSelected)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.state.item.name), 1))
            : _createCommentVNode("", true),
          (!_ctx.defaultLanguageSelected)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.state.item.nameEnglish), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(_ctx.state.item.accessPurposeDescription), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.state.item.technicalCharacteristic), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.state.item.components)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_6, _toDisplayString(_ctx.t("content.researchEquipment.content.equipmentComponentTitle")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.state.item.components)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_component_Accordion, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.item.components, (child, index_child) => {
                                  return (_openBlock(), _createBlock(_component_AccordionTab, {
                                    key: index_child,
                                    header: child.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(child.description), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["header"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_9,
              (_ctx.state.images[0])
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: "absImgBG",
                      style: _normalizeStyle([
              _ctx.state.productImage
                ? 'background-image:url(' + _ctx.state.productImage + ')'
                : '',
            ])
                    }, [
                      _createElementVNode("img", {
                        style: {"height":"308px","width":"460px"},
                        src: _ctx.state.images[0].url,
                        alt: "Equipment image"
                      }, null, 8, _hoisted_11)
                    ], 4),
                    (_ctx.state.images)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "read-more text-color-blue mt-2",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.state.showGallery = true), ["prevent"]))
                          }, [
                            _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.t("content.researchEquipment.content.photoGalleryTitle")) + "...", 1),
                            _hoisted_14
                          ]),
                          _createVNode(_component_Galleria, {
                            visible: _ctx.state.showGallery,
                            "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.showGallery) = $event)),
                            value: _ctx.state.images,
                            "num-visible": 6,
                            "container-style": "max-width: 50%",
                            circular: true,
                            "full-screen": true,
                            "show-item-navigators": true
                          }, {
                            item: _withCtx((slotProps) => [
                              _createElementVNode("img", {
                                src: slotProps.item.url,
                                alt: slotProps.item.alt,
                                style: {"width":"800px","height":"533px","display":"block"}
                              }, null, 8, _hoisted_15)
                            ]),
                            thumbnail: _withCtx((slotProps) => [
                              _createElementVNode("img", {
                                src: slotProps.item.url,
                                alt: slotProps.item.alt,
                                style: {"display":"block","max-height":"116px","max-width":"174px"}
                              }, null, 8, _hoisted_16)
                            ]),
                            _: 1
                          }, 8, ["visible", "value"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            (_ctx.state.item.researchOrganization?.name)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.state.item.researchInfrastructure?.name)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_19, [
                          (_ctx.state.item.researchOrganization)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                _createElementVNode("strong", _hoisted_21, _toDisplayString(_ctx.t(
                  "content.researchEquipment.content.memberOfTheUniversityOfMariborTitle"
                )), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", null, [
                              _createVNode(_component_IconTextBlock, {
                                icon: "icon-pin",
                                label: `${
                    _ctx.defaultLanguageSelected
                      ? `${_ctx.state.item.researchOrganization.name} <br /> ${_ctx.state.item.location?.street} <br /> ${_ctx.state.item.location?.postalCode}`
                      : `${_ctx.state.item.researchOrganization.nameEnglish} <br /> ${_ctx.state.item.location?.street} <br /> ${_ctx.state.item.location?.postalCode}`
                  }`
                              }, null, 8, ["label"])
                            ]),
                            _createElementVNode("p", null, [
                              _createVNode(_component_IconTextBlock, {
                                icon: "icon-pin",
                                label: `${_ctx.state.item.location?.departments[0]?.name}`
                              }, null, 8, ["label"])
                            ]),
                            _createElementVNode("p", null, [
                              _createVNode(_component_IconTextBlock, {
                                icon: "pi pi-link",
                                label: _ctx.state.item.researchOrganization.websiteURL,
                                href: _ctx.state.item.researchOrganization.id
                              }, null, 8, ["label", "href"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", _hoisted_23, _toDisplayString(_ctx.t("content.researchEquipment.content.researchEntityTitle")), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", null, [
                              _createVNode(_component_IconTextBlock, {
                                icon: "icon-pin",
                                label: `${
                    _ctx.defaultLanguageSelected
                      ? `${_ctx.state.item.researchInfrastructure.name}`
                      : `${_ctx.state.item.researchInfrastructure.nameEnglish}`
                  }`
                              }, null, 8, ["label"])
                            ]),
                            (_ctx.state.item.researchInfrastructure.contactUsers[0])
                              ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                                  _createVNode(_component_IconTextBlock, {
                                    icon: "icon-user",
                                    label: `${_ctx.state.item.researchInfrastructure.contactUsers[0].firstname} ${_ctx.state.item.researchInfrastructure.contactUsers[0].lastname}`
                                  }, null, 8, ["label"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.item.researchInfrastructure.contactUsers[0])
                              ? (_openBlock(), _createElementBlock("p", _hoisted_25, [
                                  _createVNode(_component_IconTextBlock, {
                                    icon: "icon-phone",
                                    label: 
                    _ctx.state.item.researchInfrastructure.contactUsers[0]
                      .phoneNumber
                  
                                  }, null, 8, ["label"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.item.researchInfrastructure.contactUsers[0])
                              ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                                  _createVNode(_component_IconTextBlock, {
                                    icon: "icon-envelope-3",
                                    label: 
                    _ctx.state.item.researchInfrastructure.contactUsers[0].email
                  
                                  }, null, 8, ["label"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.state.item.contactUsers[0])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", _hoisted_28, _toDisplayString(_ctx.t("content.researchEquipment.content.responsiblePersonTitle")), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("p", null, [
                                  _createVNode(_component_IconTextBlock, {
                                    icon: "icon-user",
                                    label: _ctx.state.responsibleUserContact.name
                                  }, null, 8, ["label"])
                                ]),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_IconTextBlock, {
                                    icon: "icon-phone",
                                    label: _ctx.state.responsibleUserContact.mobile
                                  }, null, 8, ["label"])
                                ]),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_IconTextBlock, {
                                    icon: "icon-envelope-3",
                                    label: _ctx.state.responsibleUserContact.email
                                  }, null, 8, ["label"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_29, [
              (_ctx.state.item.location)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_31, _toDisplayString(_ctx.t("content.researchEquipment.content.locationTitle")), 1)
                    ]),
                    _createVNode(_component_GoogleMapsSmall, {
                      location: _ctx.locationPosition()
                    }, null, 8, ["location"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            (_ctx.state.item.equipmentCriteria)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", _hoisted_35, _toDisplayString(_ctx.t("content.researchEquipment.content.classificationTitle")), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.researchEquipment.content.classificationMERIL")), 1),
                    _hoisted_36,
                    _createTextVNode(" " + _toDisplayString(_ctx.state.item.equipmentCriteria[_ctx.state.localProperty]), 1),
                    _hoisted_37,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.researchEquipment.content.classificationUNILeeds")), 1),
                    _hoisted_38,
                    _createTextVNode(" " + _toDisplayString(_ctx.state.item.equipmentUniLeedClassType[_ctx.state.localProperty]) + " ", 1),
                    _hoisted_39,
                    _createTextVNode(" " + _toDisplayString(_ctx.state.item.equipmentUniLeedOrderType[_ctx.state.localProperty]) + " ", 1),
                    _hoisted_40,
                    _createTextVNode(" " + _toDisplayString(_ctx.state.item.equipmentUniLeedType[_ctx.state.localProperty]) + " ", 1),
                    _hoisted_41
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.item.equipmentAccessType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", _hoisted_43, _toDisplayString(_ctx.t("content.researchEquipment.sidebar.accessTypeTitle")), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.state.item.equipmentAccessType[_ctx.state.localProperty]), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.item.equipmentAccessMethod)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", _hoisted_45, _toDisplayString(_ctx.t("content.researchEquipment.sidebar.accessMethodsTitle")), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.state.item.equipmentAccessMethod[_ctx.state.localProperty]), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.item.equipmentLifeCycleStatus)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", _hoisted_47, _toDisplayString(_ctx.t("content.researchEquipment.sidebar.lifeCycleStatusOfEquipment")), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.state.item.equipmentLifeCycleStatus[_ctx.state.localProperty]), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.item.equipmentTargetGroups)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", _hoisted_49, _toDisplayString(_ctx.t("content.researchEquipment.content.targetUserGroupTitle")), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.item.equipmentTargetGroups, (targetUser) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: targetUser.id
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(targetUser[_ctx.state.localProperty]), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_50,
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("p", null, [
                _createElementVNode("strong", _hoisted_53, _toDisplayString(_ctx.t("content.researchEquipment.content.equipmentAccessTypeTitle")), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.state.item.accessTypeDescription), 1)
            ])
          ]),
          (_ctx.state.item.researchEquipmentPrice.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_57, _toDisplayString(_ctx.t("content.researchEquipment.content.equipmentUserPriceListTitle")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_DataTable, {
                      value: _ctx.state.item.researchEquipmentPrice
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          field: "userExpertiseLevel",
                          header: 
                _ctx.t('content.researchEquipment.content.priceListUserHeaderTitle')
              
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(_ctx.t(
                    `content.researchEquipment.priceListExperienceLevel.` +
                      slotProps.data.userExpertiseLevel
                  )), 1)
                          ]),
                          _: 1
                        }, 8, ["header"]),
                        _createVNode(_component_Column, { field: "date_1" }, {
                          header: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t("content.researchEquipment.content.priceListDateRangeTitle")), 1)
                          ]),
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.dateFrom)) + " ", 1),
                            _hoisted_59,
                            _createTextVNode(" " + _toDisplayString(_ctx.formatDate(slotProps.data.dateTo)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, { field: "date_2" }, {
                          header: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t("content.researchEquipment.content.priceListPriceHeaderTitle")), 1)
                          ]),
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.data.price) + " € ", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_60,
          _createElementVNode("div", _hoisted_61, [
            (_ctx.compare)
              ? (_openBlock(), _createBlock(_component_AddToCompare, {
                  key: 0,
                  id: _ctx.state.item.id,
                  class: "mb-4"
                }, null, 8, ["id"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              type: "button",
              class: "p-button-iconEdge w-full",
              icon: "icon-chevron-right",
              "icon-pos": "right",
              label: _ctx.t('content.researchEquipment.content.bookEquipmentButton'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onBookEquipmentClick(_ctx.state.item)))
            }, null, 8, ["label"])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_Prompt, {
      visible: _ctx.state.showLoginDialog,
      title: _ctx.t('content.login.header.title'),
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.showLoginDialog = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("p", null, _toDisplayString(_ctx.t("content.login.content.text")), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.t("content.login.content.createUserAccountText")), 1),
            _hoisted_63,
            _createElementVNode("a", {
              href: "#",
              class: "link text-color-blue",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => {
              _ctx.state.showLoginDialog = false;
              _ctx.state.showRegistrationDialog = true;
            }, ["prevent"]))
            }, _toDisplayString(_ctx.t("content.login.content.createUserAccountLink")), 1)
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-outlined",
          label: _ctx.t('content.globalCancelButton'),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.showLoginDialog = false))
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          label: _ctx.t('content.login.footer.loginButton'),
          onClick: _ctx.onLoginRedirectClick
        }, null, 8, ["label", "onClick"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_Register, {
      show: _ctx.state.showRegistrationDialog,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.showRegistrationDialog = false))
    }, null, 8, ["show"])
  ], 64))
}